import { render, staticRenderFns } from "./FAriaAlert.vue?vue&type=template&id=7e1117e1&"
import script from "./FAriaAlert.vue?vue&type=script&lang=js&"
export * from "./FAriaAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports